export default __webpack_public_path__ + "static/media/sadie-o-harris-rounded.1f228c5e.png";